// extracted by mini-css-extract-plugin
var _1 = "assets-js-common-components-MegaNav-MegaNavVariant-components-LocalNav-components-Search-Search-module__meganavSearchBarWrapper__pqA0I";
var _2 = "assets-js-common-components-MegaNav-MegaNavVariant-components-LocalNav-components-Search-Search-module__meganavSearchBarWrapperHidden__PcSKC";
export { _1 as "meganavSearchBarWrapper", _2 as "meganavSearchBarWrapperHidden" }
